module.exports = require('./helpers/bundle-url').getBundleURL('hmjwG') + "azure_arm-logo.987077d6.png";